import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";

export default function NewsDigest() {
  const items = newsList.slice(0, 5);
  return (
    <section className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden">
      <div className="flex items-center justify-between px-4 md:px-5 py-4 border-b border-background-200/70">
        <h2 className="flex items-center gap-2 font-heading font-bold text-foreground-950 text-lg">
          <i className="ri-flashlight-line text-primary-500" />
          动漫资讯快览
        </h2>
        <Link to="/news" className="text-sm text-accent-600 hover:text-accent-700 cursor-pointer whitespace-nowrap">
          查看全部 <i className="ri-arrow-right-s-line align-middle" />
        </Link>
      </div>
      <ul className="divide-y divide-background-200/70">
        {items.map((news) => (
          <li key={news.id}>
            <Link
              to={`/news/${news.id}`}
              className="group flex items-start gap-3 px-4 md:px-5 py-3.5 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="mt-0.5 w-5 h-5 shrink-0 flex items-center justify-center rounded bg-primary-100 text-primary-700 text-[11px] font-bold">
                {items.indexOf(news) + 1}
              </span>
              <div className="min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {news.title}
                </h3>
                <div className="mt-1 flex items-center gap-2.5 text-[11px] text-foreground-500">
                  <span className="px-1.5 py-0.5 rounded bg-accent-100 text-accent-800">{news.categoryLabel}</span>
                  <span>{news.publishedAt}</span>
                  <span className="truncate">{news.source}</span>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}